import React, { useContext, useState, Dispatch, SetStateAction } from "react"
import Action from "../../model/Action"
import { MachineContext } from "../fsm/useMachine"
import { SET_ACTION, DELEGATE } from "../fsm/types"
import { WebLink } from "./WebLink"
import { FlowLink } from "./FlowLink"
import { MailLink } from "./MailLink"
import { FlowScreen } from "./ScreenLink"
import {XCircle} from "react-feather"

export type MaybeAction = Action | null


enum LinkMenuScreen {
    Start, FlowScreen, WebLink, MailLink, FlowLink
}

function fromAction(action: Action | null): LinkMenuScreen {
    if (!action) return LinkMenuScreen.Start
    switch (action.__tag) {
        case "flow":
            return LinkMenuScreen.FlowLink
        case "screen":
            return LinkMenuScreen.FlowScreen
        case "email":
            return LinkMenuScreen.MailLink
        case "web":
            return LinkMenuScreen.WebLink
        default:
            return LinkMenuScreen.Start
    }
}

export const LinkScreen: React.FC<LSProps> = ({
    close_screen,
    setIsWide
}) => {
    const [current,] = useContext(MachineContext)
    const currentObject = current.context.currentObject!
    const [page, setPage] = useState<LinkMenuScreen>(fromAction(currentObject?.action))
    const [action, setAction] = useState<MaybeAction>(currentObject?.action)
    if (page === LinkMenuScreen.FlowLink || action?.__tag === "flow") {
        setIsWide(false)
        let existing = action?.__tag === "flow" ? action!.value : null;
        return (
            <Wrapper
                back_action={() => setPage(LinkMenuScreen.Start)}
                close_action={close_screen}
                submit_action={action}
                setExisting={setAction}>
                <FlowLink set_action={setAction} existing={existing} />
            </Wrapper >)
    }
    else if (page === LinkMenuScreen.FlowScreen || action?.__tag === "screen") {
        setIsWide(true)
        let existing = action?.__tag === "screen" ? action!.value : undefined;
        return (
            <Wrapper
                back_action={() => setPage(LinkMenuScreen.Start)}
                close_action={close_screen}
                submit_action={action}
                setExisting={setAction}>
                <FlowScreen set_action={setAction} existing={existing} />
            </Wrapper >)
    } else if (page === LinkMenuScreen.MailLink || action?.__tag === "email") {
        setIsWide(false)
        let existing = action?.__tag === "email" ? action!.value : null;

        return (<Wrapper
            back_action={() => {
                setAction(null)
                setPage(LinkMenuScreen.Start)
            }}
            close_action={close_screen}
            submit_action={action}
            setExisting={setAction}>
            <MailLink set_action={setAction} existing={existing} />
        </Wrapper>)
    } else if (page === LinkMenuScreen.WebLink || action?.__tag === "web") {
        setIsWide(false)
        let existing = action?.__tag === "web" ? action!.value : undefined;
        return (
            <Wrapper
                back_action={() => setPage(LinkMenuScreen.Start)}
                close_action={close_screen}
                submit_action={action}
                setExisting={setAction}>
                <WebLink set_action={setAction} existing={existing} />
            </Wrapper>)
    }

    return (
        <div id="linkMenu" className="modalMenu">
            <div className="linkmenu_selections">
                <label onClick={close_screen} className="close">
                    <XCircle className="feather" />
                </label>
                <h4 className="center-text" >Choose Link Type</h4>
            </div>
            <ul>
                <li onClick={() => setPage(LinkMenuScreen.FlowScreen)}>
                    <img
                        //@ts-ignore_errors
                        loading="lazy"
                        width="24"
                        alt="link-to-screen-icon"
                        src="/include/img/creator/link-to-screen.png"
                    />
                    <span>Link to Screen</span>
                </li>
                <li onClick={() => setPage(LinkMenuScreen.WebLink)}>
                    <img
                        //@ts-ignore_errors
                        loading="lazy"
                        width="24"
                        alt="link-to-website-icon"
                        src="/include/img/creator/link-to-web.png"
                    />
                    <span>Link to Web Site</span>
                </li>
                <li onClick={() => setPage(LinkMenuScreen.MailLink)}>
                    <img
                        //@ts-ignore_errors
                        loading="lazy"
                        width="24"
                        alt="link-to-email-icon"
                        src="/include/img/creator/link-to-email.png"
                    />
                    <span>Link to Email Address</span>
                </li>
                <li onClick={() => setPage(LinkMenuScreen.FlowLink)}>
                    <img
                        //@ts-ignore_errors
                        loading="lazy"
                        width="24"
                        alt="link-to-flow-icon"
                        src="/include/img/creator/link-to-flow.png"
                    />
                    <span>Link to Flow</span>
                </li>
            </ul>
        </div>
    )
}

interface LSProps {
    close_screen: () => void
    setIsWide: (to: boolean) => void
}

interface WrapperProps {
    children: React.ReactElement
    back_action: (e?: React.MouseEvent<HTMLLabelElement>) => void
    close_action: (e?: React.MouseEvent<HTMLLabelElement>) => void
    submit_action: MaybeAction
    setExisting: Dispatch<SetStateAction<MaybeAction>>
}

export const Wrapper: React.FC<WrapperProps> = ({
    children,
    back_action,
    close_action,
    submit_action,
    setExisting
}) => {
    const [current, send] = useContext(MachineContext)

    const submit = (e: React.FormEvent) => {
        e.preventDefault()
        e.stopPropagation()
        send({ type: "MARK_INACTIVE" })
        send({ type: DELEGATE, payload: { type: SET_ACTION, action: submit_action }, id: current.context.currentObject!.id })
        close_action()
    }

    const clearAction = () => {
        send({ type: DELEGATE, payload: { type: SET_ACTION, action: null }, id: current.context.currentObject!.id })
        setExisting(null)
        close_action()
    }

    return (
        <div
            id="linkMenu"
            className="modalMenu"
        >
            <div className="label_wrapper">
                <label
                    onClick={close_action}
                    className="close padding_5"
                >
                    <XCircle className="feather" />
                </label>
                <label
                    onClick={back_action}
                    className="close padding_5"
                >
                    &lt;
                </label>
            </div>
            <div
                className="fit_content_height"
            >
                {children}
                <div className="clear_link"

                >
                    {submit_action && (
                        <button onClick={clearAction} className="linkButton">
                            Clear Link
                        </button>
                    )}
                    <button className="linkButton" onClick={submit}>Save</button>
                </div>
            </div>
        </div>
    )
}



export interface LinkProps<T> {
    set_action: Dispatch<SetStateAction<MaybeAction>>
    existing?: T | null
}
